import { Target, Heart, Book, Microscope } from 'lucide-react';

export function Mission() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="text-center mb-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Our Mission & Vision</h1>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          Advancing neurological healthcare through innovative treatment, groundbreaking research, and compassionate patient care.
        </p>
      </div>

      <div className="bg-blue-50 rounded-lg p-8 mb-16">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Our Mission Statement</h2>
        <p className="text-lg text-gray-700 mb-8">
          To provide exceptional neurological care while advancing medical knowledge through research and education, 
          improving the lives of those affected by neurological conditions through innovative treatments and compassionate service.
        </p>
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <Target className="h-10 w-10 text-blue-600 mb-4" />
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Excellence</h3>
            <p className="text-gray-600">
              Delivering the highest standard of neurological care through expertise and innovation.
            </p>
          </div>
          <div>
            <Heart className="h-10 w-10 text-blue-600 mb-4" />
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Compassion</h3>
            <p className="text-gray-600">
              Treating each patient with understanding, respect, and personalized attention.
            </p>
          </div>
          <div>
            <Microscope className="h-10 w-10 text-blue-600 mb-4" />
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Innovation</h3>
            <p className="text-gray-600">
              Advancing neurological care through research and adoption of new technologies.
            </p>
          </div>
        </div>
      </div>

      <div className="mb-16">
        <h2 className="text-2xl font-bold text-gray-900 mb-8">Our Core Values</h2>
        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-white rounded-lg p-6 shadow-md">
            <h3 className="text-lg font-semibold text-gray-900 mb-3">Patient-Centered Care</h3>
            <p className="text-gray-600">
              We put our patients first, ensuring each individual receives personalized attention and 
              comprehensive care tailored to their unique needs and circumstances.
            </p>
          </div>
          <div className="bg-white rounded-lg p-6 shadow-md">
            <h3 className="text-lg font-semibold text-gray-900 mb-3">Scientific Excellence</h3>
            <p className="text-gray-600">
              We maintain the highest standards in medical practice, continuously updating our knowledge 
              and techniques based on the latest research and evidence.
            </p>
          </div>
          <div className="bg-white rounded-lg p-6 shadow-md">
            <h3 className="text-lg font-semibold text-gray-900 mb-3">Collaborative Approach</h3>
            <p className="text-gray-600">
              We work together as a team and partner with other healthcare providers to ensure 
              comprehensive care for our patients.
            </p>
          </div>
          <div className="bg-white rounded-lg p-6 shadow-md">
            <h3 className="text-lg font-semibold text-gray-900 mb-3">Educational Leadership</h3>
            <p className="text-gray-600">
              We are committed to advancing neurological knowledge through research, education, 
              and community outreach programs.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-gray-50 rounded-lg p-8 mb-16">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Our Vision for the Future</h2>
        <p className="text-lg text-gray-700 mb-8">
          To be recognized as a leading center of excellence in neurological care, known for:
        </p>
        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Innovative Treatments</h3>
            <p className="text-gray-600 mb-4">
              Developing and implementing cutting-edge therapies that improve patient outcomes and quality of life.
            </p>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Research Leadership</h3>
            <p className="text-gray-600 mb-4">
              Contributing to the advancement of neurological science through groundbreaking research and clinical trials.
            </p>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Community Impact</h3>
            <p className="text-gray-600 mb-4">
              Serving as a trusted resource for neurological health education and support in our community.
            </p>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Global Collaboration</h3>
            <p className="text-gray-600 mb-4">
              Fostering partnerships with leading institutions worldwide to advance neurological care globally.
            </p>
          </div>
        </div>
      </div>

      <div className="text-center">
        <Book className="h-12 w-12 text-blue-600 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Join Us in Our Mission</h2>
        <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
          Whether you're a patient seeking care, a healthcare provider looking to collaborate, or a researcher 
          interested in our work, we invite you to join us in our mission to advance neurological care.
        </p>
        <button className="bg-blue-600 text-white px-8 py-3 rounded-md font-semibold hover:bg-blue-700 transition-colors">
          Contact Us Today
        </button>
      </div>
    </div>
  );
}